import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { FocusAreas } from './components/FocusAreas';
import { PhilosophySection } from './components/PhilosophySection';
import { BrandMoment } from './components/BrandMoment';
import { FloatingOrbs } from './components/FloatingOrbs';
function Divider() {
  return <div className="w-full flex justify-center py-12 opacity-30 relative z-10" data-id="element-0">
      <div className="w-1/3 md:w-1/4 h-px bg-brand-gold" data-id="element-1" />
    </div>;
}
export function App() {
  useEffect(() => {
    document.title = 'Pollock Ventures';
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-offWhite selection:bg-brand-gold/30 selection:text-brand-offWhite font-sans relative" data-id="element-2">
      <FloatingOrbs data-id="element-3" />
      <main className="relative z-10" data-id="element-4">
        <HeroSection data-id="element-5" />
        <Divider data-id="element-6" />
        <AboutSection data-id="element-7" />
        <Divider data-id="element-8" />
        <FocusAreas data-id="element-9" />
        <Divider data-id="element-10" />
        <PhilosophySection data-id="element-11" />
        <Divider data-id="element-12" />
        <BrandMoment data-id="element-13" />
      </main>
    </div>;
}